import React from "react";
import { useTranslation } from "react-i18next";
import { Box, FormControlLabel, Typography } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";

type Props = {
  formData: any;
  oldOrder: any;
  onChange(key: string): any;
};
const OrderSendMail = ({ formData, onChange, oldOrder }: Props) => {
  const { t } = useTranslation("order");
  return (
    <Box display="flex" flexDirection="column" marginTop={2}>
      <Typography variant="h5">{t("orderSendMail.sectionTitle")}</Typography>
      <FormControlLabel
        style={{ marginTop: "10px" }}
        control={
          <Checkbox
            checked={formData?.sendMailCast}
            onChange={(event) => onChange("sendMailCast")(event.target.checked)}
          />
        }
        label={t("orderSendMail.cast")}
      />
      <FormControlLabel
        style={{ marginTop: "5px" }}
        control={
          <Checkbox
            checked={formData?.sendMailOutwardDriver}
            onChange={(event) =>
              onChange("sendMailOutwardDriver")(event.target.checked)
            }
          />
        }
        label={t("orderSendMail.outwardDriver")}
      />
      <FormControlLabel
        style={{ marginTop: "5px" }}
        control={
          <Checkbox
            checked={formData?.sendMailReturnDriver}
            onChange={(event) =>
              onChange("sendMailReturnDriver")(event.target.checked)
            }
          />
        }
        label={t("orderSendMail.returnDriver")}
      />
      {oldOrder?.castNameId &&
        formData?.castNameId !== oldOrder?.castNameId && (
          <FormControlLabel
            style={{ marginTop: "10px" }}
            control={
              <Checkbox
                checked={formData?.sendCancelMailOldCast}
                onChange={(event) =>
                  onChange("sendCancelMailOldCast")(event.target.checked)
                }
              />
            }
            label={t("orderSendMail.oldCastCancel")}
          />
        )}
      {oldOrder?.outwardDriverId &&
        formData?.outwardDriverId !== oldOrder?.outwardDriverId && (
          <FormControlLabel
            style={{ marginTop: "5px" }}
            control={
              <Checkbox
                checked={formData?.sendCancelMailOldOutwardDriver}
                onChange={(event) =>
                  onChange("sendCancelMailOldOutwardDriver")(
                    event.target.checked
                  )
                }
              />
            }
            label={t("orderSendMail.oldOutwardDriverCancel")}
          />
        )}
      {oldOrder?.returnDriverId &&
        formData?.returnDriverId !== oldOrder?.returnDriverId && (
          <FormControlLabel
            style={{ marginTop: "5px" }}
            control={
              <Checkbox
                checked={formData?.sendCancelMailOldReturnDriver}
                onChange={(event) =>
                  onChange("sendCancelMailOldReturnDriver")(
                    event.target.checked
                  )
                }
              />
            }
            label={t("orderSendMail.oldReturnDriverCancel")}
          />
        )}
    </Box>
  );
};
export default OrderSendMail;
